import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ContactUs from "./pages/Contact_us/Contactus";
import Faqs from "./pages/faqs/faqs";
import AboutUs from "./pages/About_Us/aboutUs";
import Career from "./pages/Careers/career";
import Blogs from "./pages/blogs/blogs";
import BlogDetail from "./pages/blogs/blogDetail";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { BlogIdProvider } from "./Context/BlogIdContext";
import reportWebVitals from "./reportWebVitals";
import { useLayoutEffect } from "react";

const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Wrapper>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="contactus" element={<ContactUs />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="aboutus" element={<AboutUs />} />
        <Route path="career" element={<Career />} />

        <Route path="blogs" element={<Blogs />} />
        <Route path="blogDetail" element={<BlogDetail />} />
      </Routes>
    </Wrapper>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
